'use client'

/*
 * ReadReviewsButton
 *
 * The "Read reviews" button in the hero section that smooth-scrolls to the
 * reviews carousel further down the page. Tiny client component - only
 * needs JavaScript for the click handler.
 */

export default function ReadReviewsButton() {
  const handleClick = () => {
    document.getElementById('reviews-section')?.scrollIntoView({
      behavior: 'smooth',
    })
  }

  return (
    <button
      onClick={handleClick}
      className="text-blue-600 hover:text-blue-700 font-medium text-sm flex items-center space-x-1 transition-colors"
    >
      <span>Read reviews</span>
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
      </svg>
    </button>
  )
}